import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { selectError } from 'src/app/shared/error/store/selector/error.selector';

@Component({
  selector: 'app.main',
  templateUrl: './app.main.component.html',
  styleUrls: ['./app.main.component.scss'],
  standalone: false,
})
export class AppMainComponent implements OnInit {
  alertAppLevelMessage: string;
  backendUnavailable$!: Observable<boolean>;

  constructor(private store: Store) {
    this.alertAppLevelMessage = !environment.production ? `Environnement hors prod` : '';
  }

  ngOnInit(): void {
    this.backendUnavailable$ = this.store.select(selectError).pipe(
      map(error => !!error && (error as any).status === 0),
    );
  }
}
